// extracted by mini-css-extract-plugin
module.exports = {"content":"layout_content__e9iLy","contentChildren":"layout_contentChildren__eUdkk"};